import { GenerateProposal } from '../../../../Services/SmartProposal';
import dtoMapper from './dtoMapper';

const generateProposal = async (params) => {
  const body = dtoMapper(params);
  await GenerateProposal(body);
};

export default generateProposal;
